import { render, staticRenderFns } from "./PopupMenuButton.vue?vue&type=template&id=62ca4377&scoped=true&"
import script from "./PopupMenuButton.vue?vue&type=script&lang=ts&"
export * from "./PopupMenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./PopupMenuButton.vue?vue&type=style&index=0&id=62ca4377&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca4377",
  null
  
)

export default component.exports